import { connect } from "react-redux";
import { selectCurrentModalWithType } from "../../selectors/selectCurrentModalWithType";
import { componentWithProps } from "../generic/componentWithProps";
import { TypeModal } from "../modals/TypeModal";
export var DialogManagerDOM = connect(selectCurrentModalWithType(TypeModal.Dialog))(componentWithProps);



//////////////////
// WEBPACK FOOTER
// ./src/features/dialog/DialogManagerDOM.tsx
// module id = 1122
// module chunks = 3